"use client"
import { Desktop, Mobile } from "@/lib/common/MediaQueries"
import styled from "@emotion/styled"
import Image from "next/image"

const StyledImagesContainer = styled.div<{
  $height: number
  $mobileHeight?: number
  $width?: number
  $mobileWidth?: number
}>`
  position: relative;
  height: ${(p) => (p.$mobileHeight ? `${p.$mobileHeight}px` : "890px")};
  width: ${(p) => (p.$mobileWidth ? `${p.$mobileWidth}px` : "100%")};

  ${(props) => props.theme.breakpoints.up("md")} {
    height: ${(p) => (p.$height ? `${p.$height}px` : "890px")};
    width: ${(p) => (p.$width ? `${p.$width}px` : "100%")};
  }
`

type ImageContainerProps = {
  height: number
  desktopUrl: string
  mobileUrl?: string
  alt?: string
  mobileHeight?: number
  mobileWidth?: number
  width?: number
  borderRadius?: number
  objectFit?: "cover" | "contain"
}

export const ImageContainer = ({
  height,
  desktopUrl,
  mobileUrl = desktopUrl,
  alt,
  mobileHeight,
  width,
  mobileWidth,
  borderRadius = 0,
  objectFit = "cover",
}: ImageContainerProps): JSX.Element => {
  return (
    <StyledImagesContainer
      $height={height}
      $width={width}
      $mobileHeight={mobileHeight}
      $mobileWidth={mobileWidth}
    >
      <Desktop>
        <Image
          style={{ objectFit, borderRadius: `${borderRadius}px` }}
          src={desktopUrl}
          alt={alt ? alt : "image"}
          fill
        />
      </Desktop>
      <Mobile>
        <Image
          style={{ objectFit, borderRadius: `${borderRadius}px` }}
          src={mobileUrl || desktopUrl}
          alt={alt ? alt : "image"}
          fill
        />
      </Mobile>
    </StyledImagesContainer>
  )
}

export default ImageContainer
